import WPStagingCommon from '../../wpstg.js';
import 'regenerator-runtime/runtime';
import WPStagingBackup from './wpstg-backup';

let WPStagingBackupDownload;

(function($) {
  window.addEventListener('backups-tab', function() {
    WPStagingBackupDownload.listen();
  });

  WPStagingBackupDownload = {
    listen() {
      $('body')
          .off('click', '.wpstg--backup--download-modal', WPStagingBackupDownload.clickedDownload)
          .on('click', '.wpstg--backup--download-modal', WPStagingBackupDownload.clickedDownload);
    },
    clickedDownload(e) {
      WPStagingCommon.resetErrors();
      e.preventDefault();
      WPStagingBackup.isCancelled = false;

      WPStagingBackup.modal.download.data.indexFile = this.getAttribute('data-filePath');
      WPStagingBackupDownload.downloadModal();
    },
    renderPart(part, cssSelector) {
      const html = `<div class="wpstg--backups--part">
        <h2>${part.name}</h2>
        <p>File Size: ${part.fileSize}</p>
        <a download href="${part.downloadLink}">Download</a>
      </div>`;
      $(cssSelector).append(html);
    },
    downloadModal() {
      WPStagingCommon.resetErrors();

      const $modal = $('#wpstg--modal--backup--download-modal');

      WPStagingBackup.modal.download.html = $modal.html();

      WPStagingCommon.getSwalModal(false).fire({
        showConfirmButton: false,
        showCancelButton: true,
        cancelButtonText: 'Cancel',
        title: 'Download Backup',
        html: WPStagingBackup.modal.download.html,
        onRender() {
          $('.wpstg--modal--download--parts-container .wpstg--modal--fetching--data').show();
          $('.wpstg--modal--download--parts-container .wpstg--modal--download--text').hide();
          $('.wpstg--modal--download--parts-container .wpstg--modal--download--parts').hide();
          $('.wpstg--modal--download--parts-container .wpstg--modal--download--parts').html('');
          $('.wpstg--modal--download--parts-container').show();

          WPStagingCommon.ajax(
              {
                action: 'wpstg--backups--parts',
                accessToken: wpstg.accessToken,
                nonce: wpstg.nonce,
                filePath: WPStagingBackup.modal.download.data.indexFile,
              },
              function(response) {
                if (WPStagingBackup.isCancelled) {
                  return;
                }

                if (typeof response === 'undefined') {
                  $('.wpstg--modal--download--parts-container .wpstg--modal--fetching--data').hide();
                  $('.wpstg--modal--download--parts-container .wpstg--modal--download--text').show();
                  return;
                }

                if (response.error === true) {
                  $('.wpstg--modal--download--parts-container .wpstg--modal--fetching--data').hide();
                  $('.wpstg--modal--download--parts-container .wpstg--modal--download--text').show();
                  return;
                }

                response.parts.forEach((part) => {
                  WPStagingBackupDownload.renderPart(part, '.wpstg--modal--download--parts-container .wpstg--modal--download--parts');
                });

                $('.wpstg--modal--download--parts-container .wpstg--modal--fetching--data').hide();
                $('.wpstg--modal--download--parts-container .wpstg--modal--download--text').show();
                $('.wpstg--modal--download--parts-container .wpstg--modal--download--parts').show();
              },
              'json',
              false,
              0, // Don't retry upon failure
              1.25,
          );
        },
      }).then();
    },
  };
}(jQuery));

export default WPStagingBackupDownload;
